<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>

  <app-add-stock-modal [part]='this.targetItem'></app-add-stock-modal>
  <app-edit-stock-modal [part]='this.targetItem'></app-edit-stock-modal>
  <app-view-stock-modal [part]='this.targetItem'></app-view-stock-modal>
  <app-change-stock-modal [part]='this.targetItem'></app-change-stock-modal>

  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header'>Parts Register</h2>
    <div>
      <button class='btn btn-secondary' (click)='this.openModal("stockAddModal",this.targetItem)'><i class="fas fa-plus"></i> New Item</button>
    </div>
  </div>
  <br />
  <br />
  <app-grid
    entity='parts'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    [inverse]='true'
    >
  </app-grid>
</div>
